import Cookies from 'js-cookie';

export function setLanguage(language) {
  Cookies.set('language', language);
}

export function getLanguage() {
  return Cookies.get('language');
}



// WEBPACK FOOTER //
// ./src/utils/language.js